export enum LoginType {
  MOBILE = 1, // 手机登录
  QR_CODE = 2, // 微信登录
  PASSWORD = 3 // 手机号，密码登录
}

/** 账号系统： 短信验证码类型 */
export enum IPivotMobileCaptchas {
  /** 注册 */
  register = 1,
  /** 修改手机号 */
  modifyPhoneNumber,
  /** 重置密码 */
  resetPassword,
  /** 微信绑定 */
  weChatBinding,
  /** 验证码登录 */
  login,
  /** 绑定手机号 */
  phoneNumberBinding,
  /** 变更企业超管 */
  changeEnterpriseSupervision
}
